import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import externalSourcesService from '../services/externalSourcesService';

const externalSourcesCollectionName = 'external_sources';
export const useExternalSource = () => {
  return useQuery({
    queryKey: [externalSourcesCollectionName],
    queryFn: () => externalSourcesService.getAll(),
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useAddExternalSource = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: externalSourcesService.add,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [externalSourcesCollectionName] });
    },
  }); 
};

export const useEditExternalSource = () => {
    const queryClient = useQueryClient();
  
    return useMutation({
      mutationFn: externalSourcesService.edit,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [externalSourcesCollectionName] });
      },
    });
  };

export const useDeleteExternalSource = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: externalSourcesService.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [externalSourcesCollectionName] });
    },
  }); 
};

export const useExternalSourceNameById = (externalSourceId) => {
  return useQuery({
    queryKey: [externalSourcesCollectionName, externalSourceId],
    queryFn: () => externalSourcesService.getNameById(externalSourceId),
    enabled: !!externalSourceId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  }); 
}

